import Vue from "vue";
import Router from "vue-router";

import rotasAutenticacao from "./routes/autenticacao";
import rotasEmpresa from "./routes/empresa";
import rotasPrazo from "./routes/prazo";
import rotasUsuario from "./routes/usuario";
import rotasNotificacao from "./routes/notificacao";

Vue.use(Router);

export default new Router({
	mode: "history",
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		...rotasAutenticacao,
		...rotasEmpresa,
		...rotasPrazo,
		...rotasUsuario,
		...rotasNotificacao,

		{
			path: "*",
			redirect: { name: "login" }
		}
	]
});
